import { useEffect } from 'react';

import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import {
  enterFullscreen,
  useFullscreenExit,
} from '@/utils/hooks/useFullscreen';

import { SlideIn } from '../SlideIn';

type FullScreenModalProps = {
  isFullscreenModeEnabled?: boolean;
};

export const FullScreenModal: React.FC<FullScreenModalProps> = ({
  isFullscreenModeEnabled = true,
}) => {
  const { exitedFullscreen, reset } = useFullscreenExit();
  const fullScreenDisclosure = useDisclosure();
  const { t } = useTranslation(['interview']);

  useEffect(() => {
    if (exitedFullscreen && !fullScreenDisclosure.isOpen) {
      fullScreenDisclosure.onOpen();
    }
  }, [exitedFullscreen, fullScreenDisclosure]);

  // Don't render if fullscreen mode is disabled
  if (!isFullscreenModeEnabled) {
    return null;
  }

  return (
    <Modal
      motionPreset="slideInRight"
      isOpen={fullScreenDisclosure.isOpen}
      onClose={fullScreenDisclosure.onClose}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent borderRadius="xl" margin="auto">
        <ModalHeader
          w="full"
          justifyContent="center"
          borderBottom="1px solid"
          borderBottomColor="gray.50"
        >
          <Text fontWeight="medium" textAlign="center">
            {t('interview:fullscreenModalTitle')}
          </Text>
        </ModalHeader>

        <ModalBody w="full" pb={2}>
          <SlideIn>
            <Text>{t('interview:fullscreenModalDesc')}</Text>
          </SlideIn>
        </ModalBody>
        <ModalFooter>
          <Button
            mx="auto"
            variant="@primary"
            onClick={() => {
              fullScreenDisclosure.onClose();
              reset();
              enterFullscreen();
            }}
          >
            {t('interview:returnToFullScreenMode')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
